<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label">Editorial Name</label>
          <div class="col-sm-4">
            <div>
              <el-input placeholder="Editorial Name" v-model="searchName" name="search"></el-input>
            </div>
          </div>
          <label class="col-sm-2 control-label">Preference</label>
          <div class="col-sm-4">
            <div>
              <el-select v-model="preference" clearable v-bind:placeholder="$t('message.PleaseSelect')">
                <el-option v-for="item in preferencesObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label">{{ $t("message.Status") }}</label>
          <div class="col-sm-4">
            <div>
              <el-select v-model="status" clearable v-bind:placeholder="$t('message.PleaseSelect')">
                <el-option v-for="item in statusObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </div>
          </div>
          <label class="col-sm-2 control-label">Type</label>
          <div class="col-sm-4">
            <div>
              <el-select v-model="type" clearable v-bind:placeholder="$t('message.PleaseSelect')">
                <el-option v-for="item in typeObj" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label">Editorial Id</label>
          <div class="col-sm-4">
            <div>
              <el-input placeholder="Editorial Id" v-model="editorId"></el-input>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12 textRight">
            <div class>
              <button class="btn btn btn-primary" @click="search">{{ $t("message.Search") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom: 60px">
              <div class="col-xs-12">{{ total }}{{ $t("message.datagridresult") }}</div>
              <el-table :data="rows" style="width: 100%" border ref="multipleTable" @selection-change="handleSelectionChange" @sort-change="sortChange" @row-dblclick="handleDbClick">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="id" label="Editorial ID" width="130" sortable></el-table-column>
                <el-table-column prop="popular" label="Popular" width="170" sortable></el-table-column>
                <el-table-column prop="titleen_US" :show-overflow-tooltip="true" v-bind:label="$t('message.Title - Eng')" width="170"></el-table-column>
                <el-table-column prop="titlezh_HK" :show-overflow-tooltip="true" v-bind:label="$t('message.TitleTChi')" width="170"></el-table-column>
                <el-table-column prop="titlezh_CN" :show-overflow-tooltip="true" v-bind:label="$t('message.TitleSChi')" width="170"></el-table-column>
                <el-table-column prop="cardtitle" :show-overflow-tooltip="true" label="Card title" width="170"></el-table-column>
                <el-table-column prop="startTime" :show-overflow-tooltip="true" label="Start Date" width="170"></el-table-column>
                <el-table-column prop="status" v-bind:label="$t('message.Status')" width="170" sortable></el-table-column>
                <el-table-column prop="typeName" label="Type" width="170" sortable></el-table-column>
                <el-table-column fixed="right" label="" width="100">
                  <template slot-scope="scope">
                    <el-button @click="previewEvent(scope.row)" type="text" size="small">Preview</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pagesize"
                  :current-page="page + 1"
                  :total="total"
                  style="float: right"
                >
                </el-pagination>
              </el-col>
            </div>
            <div class="col-sm-12 row" style="margin-top: -30px">
              <div class="pull-right">
                <button class="btn btn-white" @click="gotoDetail" v-if="checkPermission('EDITORIAL_LIST_NEW')">{{ $t("message.Add") }}</button>
                <button class="btn btn-white" @click="showWarning" v-if="checkPermission('EDITORIAL_LIST_DELETE')">{{ $t("message.Delete") }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import eventBus from "../eventbus";
import { truncate } from "fs";
import config from "../config";

export default {
  name: "usefulLinksListController",
  mixins: [config.globalMixin],
  components: {},
  data() {
    return {
      page: 0, //当前页数
      pagesize: 10, //一页显示几条
      filter: "",
      searchName: "",
      searchStatus: null,
      total: 0,
      rows: [],
      multipleSelection: [],
      sortType: "DESC",
      sortField: "id",
      status: "",
      eventTypeObj: [],
      statusObj: [],
      preferencesObj: [],
      typeObj: [],
      preference: "",
      type: "",
      editorId: "",
    };
  },
  created: function () {
    this.typeObj = [
      {
        value: 1,
        label: "Editorial",
      },
      {
        value: 2,
        label: "Event Group",
      },
      {
        value: 3,
        label: "Event",
      },
    ];
    this.preferencesObj = [
      {
        value: "0",
        label: "Music",
      },
      {
        value: "1",
        label: "Dance",
      },
      {
        value: "2",
        label: "Xiqu",
      },
      {
        value: "3",
        label: "Design & Architecture",
      },
      {
        value: "4",
        label: "Theatre/Drama",
      },
      {
        value: "5",
        label: "Literature",
      },
      {
        value: "6",
        label: "Exhibition",
      },
      {
        value: "7",
        label: "Festivals",
      },
      {
        value: "8",
        label: "Films/Moving Image",
      },
      {
        value: "9",
        label: "Visual Culture",
      },
      {
        value: "10",
        label: "Chinese Art/Culture",
      },
      {
        value: "11",
        label: "Guided Tour",
      },
      {
        value: "12",
        label: "Workshop",
      },
      {
        value: "13",
        label: "Talks/Seminars",
      },
      {
        value: "14",
        label: "Free Events",
      },
      {
        value: "15",
        label: "Family Events",
      },
      {
        value: "16",
        label: "Pet Friendly Activities",
      },
      {
        value: "17",
        label: "Shopping",
      },
      {
        value: "18",
        label: "Dining ",
      },
    ];
    if (this.$route.query.sortField) {
      this.sortField = this.$route.query.sortField;
    }
    if (this.$route.query.page) {
      this.page = parseInt(this.$route.query.page);
    }
    if (this.$route.query.pagesize) {
      this.pagesize = parseInt(this.$route.query.pagesize);
    }
    if (this.$route.query.searchName) {
      this.searchName = this.$route.query.searchName;
    }
    if (this.$route.query.status) {
      this.status = this.$route.query.status;
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.$route.query.editorId) {
      this.editorId = this.$route.query.editorId;
    }
    if (this.$route.query.preference) {
      this.preference = this.$route.query.preference;
    }
  },
  methods: {
    async init() {
      let objdata = this.getAuthObj();
      objdata.sortField = this.sortField;
      objdata.sortType = this.sortType;
      objdata.startRow = this.page;
      objdata.maxRows = this.pagesize;
      objdata.keyword = this.searchName;
      objdata.preference = this.preference;
      objdata.type = this.type;
      objdata.id = this.editorId;
      objdata.status = this.status;
      objdata.apiUrl = "/getEditorialList";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      let list = null;
      for (var i = 0; i < data.data.resultList.length; i++) {
        for (var j = 0; j < data.data.resultList[i].langMap.length; j++) {
          if (data.data.resultList[i].langMap[j].langCode == "en_US") {
            data.data.resultList[i]["title" + "en_US"] = data.data.resultList[i].langMap[j].editorialTitle;
            data.data.resultList[i]["cardtitle"] = data.data.resultList[i].langMap[j].cardTitle;
          }
          if (data.data.resultList[i].langMap[j].langCode == "zh_HK") {
            data.data.resultList[i]["title" + "zh_HK"] = data.data.resultList[i].langMap[j].editorialTitle;
          }
          if (data.data.resultList[i].langMap[j].langCode == "zh_CN") {
            data.data.resultList[i]["title" + "zh_CN"] = data.data.resultList[i].langMap[j].editorialTitle;
          }
        }
      }
      this.rows = data.data.resultList;
      this.setObj();
      this.total = data.data.totalRows;
    },
    gotoDetail() {
      this.$router.push({
        path: "/main/editorialDetail",
        query: {
          sortField: this.sortField,
          page: this.page,
          pagesize: this.pagesize,
          searchName: this.searchName,
          status: this.status,
          type: this.type,
          editorId: this.editorId,
          preference: this.preference,
        },
      });
    },
    getStatus(data) {
      if (data.indexOf("all") < 0) {
        this.searchStatus = Number(data);
      } else {
        this.searchStatus = null;
      }
    },
    async search() {
      this.page = 0;
      this.init();
    },
    showWarning() {
      var that = this;
      if (this.multipleSelection.length != 0) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.deleteList();
              },
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () {},
            },
          ],
        });
      }
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj();
      if (this.multipleSelection.length != 0) {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
        }
      }
      objdata.ids = ids;

      objdata.apiUrl = "/deleteEditorial";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      if (data.data.errorCode === 0) {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: [],
        });
        this.init();
      }
    },
    cancel: function () {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    handleSizeChange: function (val) {
      this.pagesize = val;
      this.init();
    },
    handleCurrentChange: function (val) {
      this.page = val - 1;
      this.init();
    },
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    handleDbClick: function (row) {
      this.$router.push({
        path: "/main/editorialDetail",
        query: {
          id: row.id,
          sortField: this.sortField,
          page: this.page,
          pagesize: this.pagesize,
          searchName: this.searchName,
          status: this.status,
          type: this.type,
          editorId: this.editorId,
          preference: this.preference,
        },
      });
    },
    sortChange: function (val) {
      if (val.order == "ascending") {
        this.sortType = "ASC";
        this.sortField = val.prop;
      } else if (val.order == "descending") {
        this.sortType = "DESC";
        this.sortField = val.prop;
      } else {
        this.sortType = "ASC";
        this.sortField = "id";
      }
      this.init();
    },
    setObj: function () {
      this.statusObj = [
        {
          value: "0",
          label: this.$i18n.t("message.Inactive"),
        },
        {
          value: "1",
          label: this.$i18n.t("message.Active"),
        },
      ];
      let list = null;
      for (list of this.rows) {
        list.popular += "";
        if (list.status === 0) {
          list.status = this.$i18n.t("message.Inactive");
        } else if (list.status == 1) {
          list.status = this.$i18n.t("message.Active");
        }
        if (list.type === 1) {
          list.typeName = "Editorial";
        } else if (list.type == 2) {
          list.typeName = "Event Group";
        } else if (list.type == 3) {
          list.typeName = "Event";
        }
      }
    },
    async previewEvent(row) {
      var rnd = Date.now();

      this.$store.commit("setmagazine", {
        // id: row.id,
        type: row.type,
        rnd: rnd,
        editorial: row,
        // image:this.getObject(row.langMap,'en_US').image,
        // cardTitle:this.getObject(row.langMap,'en_US').cardTitle,
        // editorialTitle:this.getObject(row.langMap,'en_US').editorialTitle,
        boolean: true,
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
